<div class="m-3">
  <form [formGroup]="form" class="mt-3 row">
    <div class="col-md-12 mb-3">
      <p>{{'active'|translate}}</p>
      <p-inputSwitch formControlName="actif" binary="true"></p-inputSwitch>
    </div>
    <div class="col-md-6 mb-3">
      <p>{{'description'|translate}} *</p>
      <input class="form-control" type="text" pInputText formControlName="description"
        [placeholder]="'description'|translate" />
    </div>
    <div class="col-md-6 mb-3">
      <p>{{'code'|translate}} *</p>
      <input class="form-control" type="text" pInputText formControlName="code" [placeholder]="'code'|translate" />
    </div>
  </form>
  <div class="d-flex justify-content-end">
    <super-button styleClass="bottomButton red mb-3 me-3" [text]="'global.cancel'|translate"
      (click)="onClose()"></super-button>
    <super-button styleClass="bottomButton green" [disabled]="!form.valid" (click)="createClassement()"
      [text]="'btn.create'|translate"></super-button>
  </div>
</div>